<template>
  <svg class="inline-block fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 10">
    <path d="M4.333 7.456 1.2 4.796 0 6.237 4.449 10 13 1.308 11.671 0z" />
  </svg>
</template>
